




















































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import InspectList from "@/page/user/InspectList.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { inspectService } from "@/service/inspectService.ts";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { SeibiItem } from "@/model/InspectionSeibi";
import * as util from "@/service/util";
import { DO_SEIBI } from "@/model/DoSeibi";
import { EditPriceParam } from "@/model/EditPriceParam";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { MESSAGE } from "@/model/Message";

@Component({
  components: {
  }
})
export default class EstimateListComponent extends InspectList {
  @Prop() estData: any;

  addClass: any = "top-bar__override";
  activeCategory: number = 0;
  clickCount: number = 0;
  timerClick: any = null;
  service: inspectService;
  activeSubCategory: number = 0;
  currentData: any[] = [];
  isSaving: boolean = false;
  estTotalPrice: number = 0;
  isEst: boolean = false;
  isUser: boolean = false;
  // 2022-01-31 morisako kobac-free mod [START]
  freeOfChargeNm: string = '無償対応';
  // 2022-01-31 morisako kobac-free mod [END]

  created() {
    if (this.$route.name == 'estimate') {
      this.isEst = true;
      this.isUser = false;
    } else if (this.$route.name == 'usercustomer') {
      this.isEst = false;
      this.isUser = true;
    }
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
    setTimeout(() => {
      this.setCurrentData(true);
    }, 0);
  }

  showNotKouchin(item: any) {
    return (item.showNotKouchin == -1) ? "見積もり中" : "0円";
  }

  isActive(i: number) {
    return this.activeCategory == i;
  }

  isComplete(item: any) {
    // return this.service.isComplete(item);
  }

  isIncomplete(item: any) {
    // return this.service.isIncomplete(item);
  }

  onClickCategory(e: any, index: number, cate: any) {
    this.clickCount++;
    if (this.clickCount === 1) {
      this.timerClick = setTimeout(() => {
        this.changeCategory(index);
        this.clickCount = 0;
      }, 300);
    } else {
      clearTimeout(this.timerClick);
      this.clickCount = 0;
      if (index != this.activeCategory) {
        this.changeCategory(index);
      } else {
        this.dblclickCategory(index, cate);
      }
    }
  }

  changeCategory(i: number) {
    if (this.activeCategory != i) {
      this.activeCategory = i;
      this.activeSubCategory = 0;
      setTimeout(() => {
        this.setCurrentData(true);
      }, 0);
      this.scrollToFirstIncomplete();
    }
  }

  /** 2021-08-20 sh #7356  send message to customer-screen. [START] */
  updateCurrentData() {
    this.$set(this, "currentData", []);
    setTimeout(() => {
      this.setCurrentData(true);
      /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
      // window.sessionStorage.removeItem("currentIndex");
      /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
    }, 0);
  }
  /** 2021-08-20 sh #7356  send message to customer-screen. [END] */

  setCurrentData(focus:boolean) {//金額更新
    this.estTotalPrice = 0;
    if (this.estData[this.activeCategory].osusume) {
      if (this.estData[this.activeCategory].recommend && this.estData[this.activeCategory].recommend.length > 0) {
        if (this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems && this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems.length > 0) {
          const currentData = Array.from(
            this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems
          );
          this.$set(this, "currentData", currentData);
          this.currentData.forEach((element: any) => {
            if (element.doTenken == DO_SEIBI.suru) this.estTotalPrice += this.isExcludingTax ? element.totalZn : element.totalZk;
          });
          this.setListSeibi();
        } else {
          this.$set(this, "currentData", []);
        }
      } else {
        this.$set(this, "currentData", []);
      }
      this.inspectType = INSPECT_TYPE.RECOMMEND;
    } else {
      if (this.estData[this.activeCategory].subItems && this.estData[this.activeCategory].subItems.length > 0) {
        let datas: any[] = [];
        this.estData[this.activeCategory].subItems.forEach((element: any) => {
          if (element.subItems && element.subItems.length > 0) {
            element.subItems.forEach((sub: any) => {
              datas.push(sub);
              if (sub.doTenken == DO_SEIBI.suru) this.estTotalPrice += this.isExcludingTax ? sub.totalZn : sub.totalZk;
            });
          }
        });
        this.$set(this, "currentData", datas);
        this.setListSeibi();
      } else {
        this.$set(this, "currentData", []);
      }
      this.inspectType = INSPECT_TYPE.LEGAL56;
    }
    if (this.inspectType == INSPECT_TYPE.LEGAL56) {
      this.textTopTitle = "現車・法定57項目検査の結果";
    } else {
      this.textTopTitle = "おすすめ整備点検の結果";
    }
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    if(focus) this.focusInputText();
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
  }

  setListSeibi() {
    this.showPriceList = util.deepCopy(this.currentData);
    this.showPriceList.forEach((item: any) => {
      if (item.kouchinEditZk < 0) {
        item.kouchinEditZk = 0;
        item.kouchinEditZn = 0;
        item.kouchinZk = 0;
        item.kouchinZn = 0;
      }
    });
    /** 2023-10-19 invoice [START] */
    this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
    this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
    /** 2023-10-19 invoice [END] */
    /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
    // setTimeout(() => {
    //  this.scrollToCurrentIndex();
    //}, 0);
    /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
  }

  scrollToFirstIncomplete() {
  }

  dblclickCategory(index: number, cate: any) {
  }

  isSubActive(i: number, k: number) {
    return (this.activeCategory == i && this.activeSubCategory == k);
  }

  onClickSubCategory(e: any, index: number, cate: any) {
    this.clickCount++;
    if (this.clickCount === 1) {
      this.timerClick = setTimeout(() => {
        this.changeSubCategory(index);
        this.clickCount = 0;
      }, 300);
    } else {
      clearTimeout(this.timerClick);
      this.clickCount = 0;
      if (index != this.activeCategory) {
        this.changeSubCategory(index);
      } else {
        this.dblclickCategory(index, cate);
      }
    }
  }

  changeSubCategory(i: number) {
    if (this.activeSubCategory != i) {
      this.activeSubCategory = i;
      this.currentData = [];
      setTimeout(() => {
        this.setCurrentData(true);
      }, 0);
      this.scrollToFirstIncomplete();
    }
  }

  addWork() {
    if (this.manualBuhinNm) {
      /** 2023-10-19 invoice [START] */
      let manualSeibiList: any = [];
      if(this.isExcludingTax){
        manualSeibiList = [{
          seibiNm: this.manualBuhinNm,
          buhinZn: this.manualBuhinKn,
          buhinEditTotalZn: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
          , sknRecommendInspectCategoryId: (this.estData[this.activeCategory].recommend && this.estData[this.activeCategory].recommend.length > 0) ? this.estData[this.activeCategory].recommend[this.activeSubCategory].sknRecommendInspectCategoryId: null
          , sknInspectCategoryId: (this.estData && this.estData.length > 0) ? this.estData[this.activeCategory].sknInspectCategoryId: null
        }];
      }else{
        manualSeibiList = [{
        seibiNm: this.manualBuhinNm,
          buhinZk: this.manualBuhinKn,
          buhinEditTotalZk: this.manualBuhinKn,
          buhinSelected: STATUS_SELECT_WORK_BUHIN.FakeDone,
          kousuu: 0,
          manualBuhinList: []
          , sknRecommendInspectCategoryId: (this.estData[this.activeCategory].recommend && this.estData[this.activeCategory].recommend.length > 0) ? this.estData[this.activeCategory].recommend[this.activeSubCategory].sknRecommendInspectCategoryId: null
          , sknInspectCategoryId: (this.estData && this.estData.length > 0) ? this.estData[this.activeCategory].sknInspectCategoryId: null
        }];
      }
      /** 2023-10-19 invoice [END] */
      const data: any = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        sknInspectType: INSPECT_TYPE.USER_MANUAL,
        manualSeibiList: manualSeibiList
      };
      this.saveManualAk5(data);
      this.manualBuhinNm = "";
      /** 2023-10-19 invoice [START] */
      this.manualBuhinKn = null;
      /** 2023-10-19 invoice [END] */
    }
  }

  clickDoTenkenEst(item: any, doSeibi: number, index: number) {
    this.clickDoTenken(item, doSeibi, index);
    if (this.estData[this.activeCategory].osusume) {
      if (this.estData[this.activeCategory].recommend && this.estData[this.activeCategory].recommend.length > 0) {
        if (this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems && this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems.length > 0) {
          this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems.forEach((element: any, i: number) => {
            if (i == index) element.doTenken = doSeibi;
          });
        }
      }
    } else {
      if (this.estData[this.activeCategory].subItems && this.estData[this.activeCategory].subItems.length > 0) {
        this.estData[this.activeCategory].subItems.forEach((element: any) => {
          if (element.subItems && element.subItems.length > 0) {
            element.subItems.forEach((sub: any, i: number) => {
              if (i == index) sub.doTenken = doSeibi;
            });
          }
        });
      }
    }
    window.sessionStorage.setItem("currentIndex", index.toString());
    setTimeout(() => {
      this.setCurrentData(true);
    }, 0);
  }

  /** 2021-10-04 sh #7448 implements updatePriceManualSeibi for manual-seibi. [START] */
  updatePriceManualSeibi() {//更新
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    let id = '';
    // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    let newdata:any = {};
    this.currentData.map((data: any, index: number) => {
      if (
        data.kouchinEditZk != this.showPriceList[index].kouchinEditZk ||
        data.buhinEditTotalZk != this.showPriceList[index].buhinEditTotalZk
      ) {
        //// 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
        //if (data.kouchinEditZk != this.showPriceList[index].kouchinEditZk) {
        //  id = 'kouchinEditZk' + index.toString();
        //} else {
        //  id = 'buhinEditTotalZk' + index.toString();
        //}
        //// 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
        //data.kouchinEditZk = this.showPriceList[index].kouchinEditZk;
        //data.buhinEditTotalZk = this.showPriceList[index].buhinEditTotalZk;
      //  this.updateDotenken(data);
        //let paramUpdate = {} as EditPriceParam;
        //paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
        //let buhinEditTotalZk =
        //  data.buhinEditTotalZk == data.buhinZk
        //    ? null
        //    : data.buhinEditTotalZk || 0;
        //let kouchinEditZk =
        //  data.kouchinEditZk == data.kouchinZk ? null : data.kouchinEditZk || 0;
        //paramUpdate.kouchinEditZk = kouchinEditZk;
        //paramUpdate.buhinEditTotalZk = buhinEditTotalZk;

        newdata.kouchinZk = this.showPriceList[index].kouchinEditZk;
        newdata.buhinZk = this.showPriceList[index].buhinEditTotalZk;
        newdata.kouchinZn = this.showPriceList[index].kouchinEditZn;
        newdata.buhinZn = this.showPriceList[index].buhinEditTotalZn;



//        if (data.sknUketsukeManualSeibiId) {
//          paramUpdate.sknUketsukeInspectSeibiManualId =
//            data.sknUketsukeManualSeibiId;
//        } else {
//          paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
//        }
//        data.totalZk = this.itemTotalZk(data);
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//        window.sessionStorage.setItem("currentId", id);
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//        this.reqUpdatePriceJizen(paramUpdate, data);
        this.reqUpdatePriceSetDataJizen(data,index,newdata,id,1);
      /** 2023-10-19 invoice [START] */
      }else if (
        data.kouchinEditZn != this.showPriceList[index].kouchinEditZn ||
        data.buhinEditTotalZn != this.showPriceList[index].buhinEditTotalZn
      ) {
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//        if (data.kouchinEditZn != this.showPriceList[index].kouchinEditZn) {
//          id = 'kouchinEditZn' + index.toString();
//        } else {
//          id = 'buhinEditTotalZn' + index.toString();
//        }
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//        data.kouchinEditZn = this.showPriceList[index].kouchinEditZn;
//        data.buhinEditTotalZn = this.showPriceList[index].buhinEditTotalZn;
//        this.updateDotenken(data);
//        let paramUpdate = {} as EditPriceParam;
//        paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
//        let buhinEditTotalZn =
//          data.buhinEditTotalZn == data.buhinZn
//            ? null
//            : data.buhinEditTotalZn || 0;
//        let kouchinEditZn =
//          data.kouchinEditZn == data.kouchinZn ? null : data.kouchinEditZn || 0;
//        paramUpdate.kouchinEditZn = kouchinEditZn;
//        paramUpdate.buhinEditTotalZn = buhinEditTotalZn;
        newdata.kouchinZk = this.showPriceList[index].kouchinEditZk;
        newdata.buhinZk = this.showPriceList[index].buhinEditTotalZk;
        newdata.kouchinZn = this.showPriceList[index].kouchinEditZn;
        newdata.buhinZn = this.showPriceList[index].buhinEditTotalZn;
//        if (data.sknUketsukeManualSeibiId) {
//          paramUpdate.sknUketsukeInspectSeibiManualId =
//            data.sknUketsukeManualSeibiId;
//        } else {
//          paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
//        }
//        data.totalZn = this.itemTotalZn(data);
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//        window.sessionStorage.setItem("currentId", id);
//        // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//        this.reqUpdatePriceJizen(paramUpdate, data);
        this.reqUpdatePriceSetDataJizen(data,index,newdata,id,2);
      /** 2023-10-19 invoice [END] */
      }
    });
  }

  reqUpdatePriceSetDataJizen(data: any , index: number,newdata:any ,id:string,type:number){
  //  let id = '';  
    let doUpdate = false;
    let paramUpdate = {} as EditPriceParam;
    paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;

    //if ((data.kouchinEditZk != null || data.buhinEditTotalZk != null) &&
    //(data.kouchinEditZk != data.kouchinZk || data.buhinEditTotalZk != data.buhinZk)) {
    //  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
    //  if (data.kouchinEditZk != this.showPriceList[index].kouchinEditZk) {
    //    id = 'kouchinEditZk' + index.toString();
    //  } else {
    //    id = 'buhinEditTotalZk' + index.toString();
    //  }
    //  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
    //  data.kouchinEditZk = data.kouchinZk;
    //  data.buhinEditTotalZk = data.buhinZk;
    //  this.showPriceList[index].kouchinEditZk = data.kouchinZk;
    //  this.showPriceList[index].buhinEditTotalZk = data.buhinZk;
//
    //  paramUpdate.kouchinEditZk = data.kouchinZn;
    //  paramUpdate.buhinEditTotalZk = data.buhinZk;
    //  doUpdate = true; //更新実行
    //}
    if (
        type == 1 && (
        data.kouchinEditZk != newdata.kouchinZk ||
        data.buhinEditTotalZk != newdata.buhinZk )
    ) {
      if (data.kouchinEditZk != newdata.kouchinZk) {
        id = 'kouchinEditZk' + index.toString();
      } else {
        id = 'buhinEditTotalZk' + index.toString();
      }
      data.kouchinEditZk = newdata.kouchinZk;
      data.buhinEditTotalZk = newdata.buhinZk;
      paramUpdate.kouchinEditZk = newdata.kouchinZk == data.kouchinZk ? null : newdata.kouchinZk || 0;
      paramUpdate.buhinEditTotalZk = newdata.buhinZk == data.buhinZk ? null : newdata.buhinZk || 0;
      doUpdate = true; //更新実行
    }else if ((data.kouchinEditZk != null || data.buhinEditTotalZk != null) &&
      (data.kouchinEditZk != newdata.kouchinZk || data.buhinEditTotalZk != newdata.buhinZk)) {
      if (data.kouchinEditZk != newdata.kouchinZk) {
        id = 'kouchinEditZk' + index.toString();
      } else {
        id = 'buhinEditTotalZk' + index.toString();
      }
      data.kouchinEditZk = newdata.kouchinZk;
      data.buhinEditTotalZk = newdata.buhinZk;
      this.showPriceList[index].kouchinEditZk = newdata.kouchinZk;
      this.showPriceList[index].buhinEditTotalZk = newdata.buhinZk;
      paramUpdate.kouchinEditZk = newdata.kouchinZk;
      paramUpdate.buhinEditTotalZk = newdata.buhinZk;
      doUpdate = true; //更新実行
    }

    
//    if ((data.kouchinEditZn != null || data.buhinEditTotalZn != null) &&
//    (data.kouchinEditZn != data.kouchinZn || data.buhinEditTotalZn != data.buhinZn)) {
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//      if (data.kouchinEditZn != this.showPriceList[index].kouchinEditZn) {
//        id = 'kouchinEditZn' + index.toString();
//      } else {
//        id = 'buhinEditTotalZn' + index.toString();
//      }
//
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//      data.kouchinEditZn = data.kouchinZn;
//      data.buhinEditTotalZn = data.buhinZn;
//      this.showPriceList[index].kouchinEditZn = data.kouchinZn;
//      this.showPriceList[index].buhinEditTotalZn = data.buhinZn;
//
//      paramUpdate.kouchinEditZn = data.kouchinZn;
//      paramUpdate.buhinEditTotalZn = data.buhinZk;
//      doUpdate = true; //更新実行
//    }
    if (
        type == 2 && (
        data.kouchinEditZn != newdata.kouchinZn ||
        data.buhinEditTotalZn != newdata.buhinZn )
    ) {
      if (data.kouchinEditZn != newdata.kouchinZn) {
        id = 'kouchinEditZn' + index.toString();
      } else {
        id = 'buhinEditTotalZn' + index.toString();
      }
      data.kouchinEditZn = newdata.kouchinZn;
      data.buhinEditTotalZn = newdata.buhinZn;
      paramUpdate.kouchinEditZn = newdata.kouchinZn == data.kouchinZn ? null : newdata.kouchinZn || 0;
      paramUpdate.buhinEditTotalZn = newdata.buhinZn == data.buhinZn ? null : newdata.buhinZn || 0;
      doUpdate = true; //更新実行
    }else if ((data.kouchinEditZn != null || data.buhinEditTotalZn != null) &&
      (data.kouchinEditZn != newdata.kouchinZn || data.buhinEditTotalZn != newdata.buhinZn)) {
      if (data.kouchinEditZn != newdata.kouchinZn) {
        id = 'kouchinEditZn' + index.toString();
      } else {
        id = 'buhinEditTotalZn' + index.toString();
      }
      data.kouchinEditZn = newdata.kouchinZn;
      data.buhinEditTotalZn = newdata.buhinZn;
      this.showPriceList[index].kouchinEditZn = newdata.kouchinZn;
      this.showPriceList[index].buhinEditTotalZn = newdata.buhinZn;
      paramUpdate.kouchinEditZn = newdata.kouchinZn;
      paramUpdate.buhinEditTotalZn = newdata.buhinZn;
      doUpdate = true; //更新実行
    }



    if ( doUpdate ){
      this.updateDotenken(data);

      if (data.sknUketsukeManualSeibiId) {
        paramUpdate.sknUketsukeInspectSeibiManualId =
          data.sknUketsukeManualSeibiId;
      } else {
        paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
      }
      if(type == 0 || type == 1 ){
      data.totalZk = this.itemTotalZk(data);
      }
      if(type == 0 || type == 2 ){
      data.totalZn = this.itemTotalZn(data);
      }
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
      window.sessionStorage.setItem("currentId", id);
      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
      this.reqUpdatePriceJizen(paramUpdate, data);
    }

  }

  reqUpdatePriceJizen(paramUpdate: any, data: any) {
    const promise = this.reqUpdatePricePM(paramUpdate);
    this.isSaving = true;
    Promise.all([promise]).then((val: any) => {
      if (val && val.length > 0) {
        let res = val[0];
        if (res) {
          /** 2023-10-19 invoice [START] */
          this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
          this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
          /** 2023-10-19 invoice [END] */
          //工場側事前見積もり編集モーダルでの動作時、
          //画面ちらつきと更新後フォーカスが戻る原因なので停止
          //this.updateCurrentData();
          this.setCurrentData(false);
        }
      }
      this.isSaving = false;
    }, (err: any) => {
      this.isSaving = false;
    })
  }

  reqUpdatePricePM(paramUpdate: any) {
    const promise = new Promise((resolve, reject) => {
      this.reqService.updatePrice(paramUpdate).then((res: any) => {
        resolve(res);
      }, (err: any) => {
        reject(err);
      });
    });

    return promise;
  }

  resetPriceJizen(data: SeibiItem, index: number) {
    let id = '';  
    let newdata:any = {};
//    let doUpdate = false;
//    let paramUpdate = {} as EditPriceParam;
//    paramUpdate.sknUketsukeExtendsId = this.uketsukeExtendsId;
//
//    if ((data.kouchinEditZk != null || data.buhinEditTotalZk != null) &&
//    (data.kouchinEditZk != data.kouchinZk || data.buhinEditTotalZk != data.buhinZk)) {
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//      if (data.kouchinEditZk != this.showPriceList[index].kouchinEditZk) {
//        id = 'kouchinEditZk' + index.toString();
//      } else {
//        id = 'buhinEditTotalZk' + index.toString();
//      }
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//      data.kouchinEditZk = data.kouchinZk;
//      data.buhinEditTotalZk = data.buhinZk;
//      this.showPriceList[index].kouchinEditZk = data.kouchinZk;
//      this.showPriceList[index].buhinEditTotalZk = data.buhinZk;
//
//      paramUpdate.kouchinEditZk = data.kouchinZn;
//      paramUpdate.buhinEditTotalZk = data.buhinZk;
//      doUpdate = true; //更新実行
//    }
//    if ((data.kouchinEditZn != null || data.buhinEditTotalZn != null) &&
//    (data.kouchinEditZn != data.kouchinZn || data.buhinEditTotalZn != data.buhinZn)) {
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//      if (data.kouchinEditZn != this.showPriceList[index].kouchinEditZn) {
//        id = 'kouchinEditZn' + index.toString();
//      } else {
//        id = 'buhinEditTotalZn' + index.toString();
//      }
//
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//      data.kouchinEditZn = data.kouchinZn;
//      data.buhinEditTotalZn = data.buhinZn;
//      this.showPriceList[index].kouchinEditZn = data.kouchinZn;
//      this.showPriceList[index].buhinEditTotalZn = data.buhinZn;
//
//      paramUpdate.kouchinEditZn = data.kouchinZn;
//      paramUpdate.buhinEditTotalZn = data.buhinZk;
//      doUpdate = true; //更新実行
//    }
//
//    if ( doUpdate ){
//      this.updateDotenken(data);
//
//      if (data.sknUketsukeManualSeibiId) {
//        paramUpdate.sknUketsukeInspectSeibiManualId =
//          data.sknUketsukeManualSeibiId;
//      } else {
//        paramUpdate.sknUketsukeInspectSeibiId = data.sknInspectSeibiId;
//      }
//      data.totalZk = this.itemTotalZk(data);
//      data.totalZn = this.itemTotalZn(data);
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
//      window.sessionStorage.setItem("currentId", id);
//      // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]
//      this.reqUpdatePriceJizen(paramUpdate, data);
    /** 2023-10-19 invoice [START] */
    //this.setCurrentData(true);
//    }
    newdata.kouchinZk = data.kouchinZk;
    newdata.buhinZk = data.buhinZk;
    newdata.kouchinZn = data.kouchinZn;
    newdata.buhinZn = data.buhinZn;
    this.reqUpdatePriceSetDataJizen(data,index,newdata,id,0);

  }

  itemTotalZk(seibi: any) {
    let buhinEditTotalZk = seibi.buhinEditTotalZk;
    let kouchinEditZk = seibi.kouchinEditZk;
    if (seibi.buhinEditTotalZk === null) {//
      buhinEditTotalZk = seibi.buhinZk;
    }
    if (seibi.kouchinEditZk === null) {
      kouchinEditZk = seibi.kouchinZk;
    }
    return (buhinEditTotalZk == null ? 0 : buhinEditTotalZk) + (kouchinEditZk == null ? 0 : kouchinEditZk);
  }
  /** 2021-10-04 sh #7448 implements updatePriceManualSeibi for manual-seibi. [END] */
  /** 2023-10-19 invoice [START] */
  itemTotalZn(seibi: any) {
    let buhinEditTotalZn = seibi.buhinEditTotalZn;
    let kouchinEditZn = seibi.kouchinEditZn;
    if (seibi.buhinEditTotalZn === null) {
      buhinEditTotalZn = seibi.buhinZn;
    }
    if (seibi.kouchinEditZn === null) {
      kouchinEditZn = seibi.kouchinZn;
    }
    return (buhinEditTotalZn == null ? 0 : buhinEditTotalZn) + (kouchinEditZn == null ? 0 : kouchinEditZn);
  }
  /** 2023-10-19 invoice [END] */
  scrollToCurrentIndex() {
	  let currentIndex = window.sessionStorage.getItem("currentIndex");
    if (currentIndex) {
      const div = document.getElementById("div-row-" + currentIndex);
      let wrap = document.querySelector(".select-item-wrap-modal");
      setTimeout(() => {
        if (div && wrap) {
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
          window.sessionStorage.removeItem("currentIndex");
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
          const pos = 50 * Number(currentIndex);
          wrap.scrollTo(0, pos);
        }
      }, 100); // change from 0 to 100.
    }
  }

  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.freeOfChargeNm) {
        this.freeOfChargeNm = res.freeOfChargeNm;
      }
    });
  }
  // 2022-01-31 morisako kobac-free add [END]

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  clickDoTenken(
    item: any,
    doTenken: number,
    index: number,
    isSave: boolean = true
    , isAll: boolean = false
  ) {
    if (item.doTenken == doTenken) {
      return;
    }
    if (item) {
      if (item.inspectResult != InspectButtonValue.CROSS) {
        this.indexTooltip = -1;
      }
      item.doTenken = doTenken;
      if (this.isEditPrice && index >= 0 && doTenken != 1) {
        this.showPriceList[index].kouchinEditZk = this.listSeibi[
          index
        ].kouchinEditZk;
        this.showPriceList[index].buhinEditTotalZk = this.listSeibi[
          index
        ].buhinEditTotalZk;
      }
      this.updateDotenken(item);
  /** 2023-10-19 invoice [START] */
      this.totalPriceZn = this.sumPrice(this.inspectType).totalZn;
      this.totalPriceZk = this.sumPrice(this.inspectType).totalZk;
  /** 2023-10-19 invoice [END] */
      if (!isAll) {
        this.updateDoTenkenCallApi(item, doTenken, isSave);
      }
    }
  }

  updateDoTenkenCallApi(
    item: any
    , doTenken: number
    , isSave: any
  ) {
    var promiseAll: any = [];
    if (isSave) {
      const pMain = this.updateDoTenkenPM(
        this.uketsukeExtendsId
        , doTenken
        , item.sknInspectId
        , item.sknInspectSeibiId
        , item.sknUketsukeManualSeibiId
      );
      promiseAll.push(pMain);
    }
    if (this.inspectType ==INSPECT_TYPE.RECOMMEND  && item.sknInspectDescriptionSeibiId == 0) {
      this.estData[this.activeCategory].recommend[this.activeSubCategory].subItems.forEach((seibi: any, i: number) => {
        if (seibi.rowNum == 0 && item.sknRecommendInspectCategoryId == seibi.sknRecommendInspectCategoryId
          && seibi.sknInspectDescriptionSeibiId != item.sknInspectDescriptionSeibiId) {
          const pSub = this.updateDoTenkenPM(
            this.uketsukeExtendsId
            , doTenken
            , seibi.sknInspectId
            , seibi.sknInspectSeibiId
            , seibi.sknUketsukeManualSeibiId
          );
          promiseAll.push(pSub);
          this.clickDoTenken(seibi,doTenken,i, isSave, true);
        }
      });
    }
    Promise.all(promiseAll).then((retList: any) => {
    }, ((err: any) => {
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    }));
  }
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [START]
  focusInputText() {
    const currentId = window.sessionStorage.getItem("currentId") ? window.sessionStorage.getItem("currentId") : '';
    if (currentId) {
      setTimeout(() => {
        const div = document.getElementById(currentId);
        if (div) {
          // window.sessionStorage.removeItem("currentId");
          const child = div.childNodes[1] as HTMLElement;
          child.focus();
        }
      }, 300);
    }
  }
  // 2022-07-00 BQR1109 手入力作業の工賃変更対応 add [END]

}
